import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { ShopBreadcrumbs } from './ShopBreadcrumbs.js';
import { ShopCarousel } from './ShopCarousel.jsx';
import { ShopGrid } from './ShopGrid.jsx';
import { ShopList } from './ShopList.jsx';

import styles from './styles/ShopWrapper.scss';

function ShopWrapperComponent({ landingPage }) {
    return (
        <Fragment>
            <ShopBreadcrumbs landingPage={landingPage} />
            <h1 className={styles.title} data-tn={`page-title-${landingPage.title}`}>
                {landingPage.title}
            </h1>
            {!!landingPage.description && (
                <p className={styles.description}>{landingPage.description}</p>
            )}
            <ShopCarousel landingPage={landingPage} />
            <ShopGrid landingPage={landingPage} />
            <ShopList landingPage={landingPage} />
        </Fragment>
    );
}

ShopWrapperComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopWrapper = createFragmentContainer(ShopWrapperComponent, {
    landingPage: graphql`
        fragment ShopWrapper_landingPage on LandingPage {
            ...ShopBreadcrumbs_landingPage
            ...ShopCarousel_landingPage
            ...ShopGrid_landingPage
            ...ShopList_landingPage
            title
            description
        }
    `,
});
